/**
 * @file 登录相关的常量
 * @author lian.duan 2023-01-31
 */

// 企业版登录接口
export const ENTERPRISE_LOGIN_API = '/api/v2/login'
// 企业版获取手机验证码接口
export const ENTERPRISE_CAPTCHA_API = '/api/v2/code'
